<!-- <app-header></app-header> -->
<router-outlet></router-outlet>

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<div id="attractions" class="container my-5">
    <div class="row">
        <!-- Left Side -->
        <div class="col-md-12 col-12 mb-4 d-flex align-items-center justify-content-center flex-column text-center">
            <h1 class="explore-heading">EXPLORE</h1>
            <h1 class="explore-subheading">THE CITY</h1>
            <p class="description">
                Our knowledgeable concierge team can assist you in planning your itinerary and arranging tours, tickets, and transportation.
            </p>
            <a (click)="scrollToSection('location')" class="contact-button btn btn-primary">Contact Us</a>
        </div>

        <!-- Right Side (Grid of Images) -->
        <!-- {{this.token?.getProperty()?.address?.city}} -->
        <!-- <div class="col-md-7 col-12">
          <main *ngIf="blogPosts$ | async as blogPosts">
            <div *ngFor="let blogPost of blogPosts.items; let i = index">
            <div class="row" >
              <ng-container *ngFor="let item of blogPost.fields.citiesimages; let j = index">
              <div  class="col-md-6 col-12 mb-4" *ngIf="j < 4 && blogPost.fields.title === this.tokenStorage?.getProperty()?.address?.city">

                  <div *ngIf="blogPost.fields.title === this.tokenStorage?.getProperty()?.address?.city ">

                      <div class="card" style="z-index: 1; margin-bottom: -40px; border-radius: 15px;">
                        <img [src]="item.fields.file.url" class="card-img-top" style="border-radius: 15px;height:200px" alt="This Temple">
                      </div>
                      <div class="card-body text-center card-body-style" style="background-color: var(--primary) !important; margin-left: -10px; margin-right: -10px; border-radius: 10px; padding-top: 50px;">
                        <h5 class="card-title" style="color: white !important;">{{ item.fields.title }}</h5>
                      </div>

                  </div>

              </div>
              </ng-container >
            </div>

          </div>
          </main>
        </div> -->


            </div>
</div>

<div class="nearby-places-section">
  <h2 class="section-heading">Nearby Places</h2>
  <div class="unique-cards-container d-none d-md-flex">
    <div class="card unique-card">
      <img src="assets/images/Poolside Picnic.jpg" class="card-img-top" alt="Poolside Picnic">
      <div class="card-body">
        <p class="card-text">Poolside Picnic</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/small party venus.jpg" class="card-img-top" alt="Small Party Venus">
      <div class="card-body">
        <p class="card-text">Small Party Venus</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/swimming class.jpg" class="card-img-top" alt="Swimming Class">
      <div class="card-body">
        <p class="card-text">Khandoba Temple</p>
      </div>
    </div>
  </div>
</div>




<div class="unique-carousel-wrapper d-block d-md-none">
  <h2 class="section-heading">Our Services</h2>
  <div class="unique-carousel-card shadow-lg border-0 rounded overflow-hidden">
    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
      <div class="carousel-inner unique-carousel-inner">
        <!-- Loop through the items using Angular's *ngFor -->
        <div
          *ngFor="let item of carouselItems; let i = index"
          class="carousel-item"
          [ngClass]="{ 'active': i === 0 }"
        >
          <div class="unique-carousel-item-content text-center p-3">
            <div class="unique-carousel-item-card">
              <img [src]="item.imgSrc" [alt]="item.title" class="img-fluid circular-image">
              <h2 class="mt-3">{{ item.title }}</h2>
              <p>{{ item.age }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Carousel Controls -->
      <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</div>









  <div class="container my-5">
    <div class="row" id="testimonials">
      <!-- First Column -->
      <div class="col-md-4 mb-4 d-flex flex-column justify-content-center align-items-start">
        <h2 class="headline font-weight-bold mb-3">Real Stays, Real Talk</h2>
        <p class="intro-text mb-4 text-muted">Here's what our guests are saying...</p>
        <a href="https://search.google.com/local/writereview?placeid=ChIJ2Q-LAQCpGToRu5OkpWEW-0s">
          <div style="padding: 10px 20px; background: black; color: white; border-radius: 25px;">
            Write a Review
          </div>
        </a>
      </div>

      <!-- Second Column (Carousel for Desktop) -->
      <div class="col-md-8 mb-4 d-md-block">
        <div class="carousel-controls">
          <a href="#carouselExampleControlsreview" role="button" data-slide="prev" class="carousel-control-prev">
            <span aria-hidden="true" class="carousel-control-prev-icon"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a href="#carouselExampleControlsreview" role="button" data-slide="next" class="carousel-control-next">
            <span aria-hidden="true" class="carousel-control-next-icon"></span>
            <span class="sr-only">Next</span>
          </a>
      </div>
      <div class="card shadow-sm border-0 h-100">
        <div id="carouselExampleControlsreview" data-ride="carousel" class="carousel slide">
          <div class="carousel-inner style_carasol" style="display: block;">

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Riya Dhar</h5>
                    <p class="small text-muted mb-2 review-text">The rooms were tidy and well-equipped with AC, free WiFi, and a Western-style washroom. The staff were super helpful and respectful. There's a water purifier on the 2nd floor for drinking water. Though room service for food isn't provided but there are lots of dining options nearby, including breakfast, lunch, dinner, and coffee/tea. Rooms were cleaned immediately after checkout. I would recommend this place to my friends & relatives as well.</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Asim Arbind</h5>
                    <p class="small text-muted mb-2 review-text">Very nice owner with great formalities, feeling of love, happiness n warmth of all the brothers n sisters over there. Great place to stay. Recommended for all to please come n verify soon. They take their complaints respectfully n work honestly to give world class service to all people.</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item active carousel-item-left">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Suman Mahapatra</h5>
                    <p class="small text-muted mb-2 review-text">The hotel was so good I stayed there for 2 days, and it was a very nice experience. The reception staff was so good and polite, the rooms were so clean, and the view from the balcony was also good. They have a good parking space. Everything was on top. If you are planning a trip or anything, you must consider this hotel</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item carousel-item-next carousel-item-left">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Suman Barua</h5>
                    <p class="small text-muted mb-2 review-text">I recently had the pleasure of staying at Hotel Grand Balaji in Bhubaneswar, and I must say, it exceeded all my expectations for a budget hotel. This place truly stands out, offering a level of service and quality that is often hard to find in many 4-star hotels. The cleanliness and hygiene of the rooms and bathrooms were particularly impressive. In fact, I would say they were on par with, if not better than, what you'd expect at luxury hotels or resorts. The rooms were spotless, well-maintained, and extremely comfortable, ensuring a pleasant stay throughout. The staff at Hotel Grand Balaji were exceptionally courteous, professional, and always ready to assist with any request. The service provided was top-notch, and they went out of their way to make sure everything was to my satisfaction. Overall, I highly recommend Hotel Grand Balaji to anyone looking for affordable yet high-quality accommodation in Bhubaneswar. It is a perfect example of how a budget hotel can offer a superior experience in terms of cleanliness, service, and comfort. I wish the hotel and its staff all the best for their future endeavors. Thank you for a memorable stay!</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="Koustubh Mangrulkar" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">adyasha das</h5>
                    <p class="small text-muted mb-2 review-text">I stayed there for 8-9 days due to hospital purposes & my stay is so calm and sound. They don't hassle for anything. They understood that we are here for medical purpose so they are empathetic regarding it and never hassle for money or anything. They maintain cleanliness also. Rooms are top class. Worth the money. Must stay!</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="pavi rajendran" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Usha usha</h5>
                    <p class="small text-muted mb-2 review-text">Hotel is well cleaned.and service is good.</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>





  </div>
</div>






  <div id="location" style="margin-bottom: 2px;">
  <div style="position: relative; width: 100%; max-width: 100%; height: 600px;">
    <!-- The iframe -->
   <iframe src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d120383.5231032356!2d85.68190481310819!3d20.279853335237963!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3a19a900018b0fd9%3A0x4bfb1661a5a493bb!2sK8-110%20Kalinga%20Nagar%2C%20Shampur%2C%20Bhubaneswar%2C%20Odisha%20751003!3m2!1d20.279872599999997!2d85.76430649999999!5e1!3m2!1sen!2sin!4v1746861571805!5m2!1sen!2sin" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    <div   class="card" style="position: absolute; top: 50px; text-align: center; left: 50px; background-color: white; border-bottom-left-radius: 61px;box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-top-right-radius: 59px;
    padding: 50px;">
        <h3>Make Unforgettable Memories</h3>
        <p>We're here to assist you with any questions, requests, or bookings.<br> Please don't hesitate to reach out to us.</p>
        <button class="book-btn" (click)="navigate()">Book Your Stay</button>
        <p class="contact-footer">
          <i class="fa fa-phone"></i> {{property?.mobile}}
        </p>
        <p class="contact-footer">
          <i class="fa fa-envelope"></i> {{property?.email}}
        </p>

      </div>

  </div>
</div>
<!-- Dialogflow Messenger Integration -->

<df-messenger project-id="impactful-name-306810" agent-id="8bb6c52c-8667-4a24-a789-4cd78b154c96" intent="WEBSITE" storage-option="none" language-code="en" max-query-length="-1"   >
  <df-messenger-chat-bubble  id="chatbot" chat-subtitle=""></df-messenger-chat-bubble>
</df-messenger>
<a [href]="getWhatsappShareUrl()" class="float" target="_blank" >
  <i class="fa fa-whatsapp my-float"></i>
</a>

<app-footer></app-footer>

